import { t } from 'ttag'

export function RequiredMark() {
  return <span className="bg-red-100 text-red-600 ml-2">{t`* 必須`}</span>
}
